import useRestAPI from './useRestAPI';

export default useRestAPI;
